export default {
    // Vue 3 v-model on a component uses modelValue/update:modelValue. We accept
    // the legacy `value`/`input` too so nothing has to change at call sites.
    props: {
        value: {
            default: undefined,
        },
        modelValue: {
            default: undefined,
        }
    },
    emits: ['input', 'update:modelValue'],
    data() {
        return {
            showModal: false,
            preloader: false
        }
    },
    watch: {
        showModal: function (value) {
            if (!value) {
                this.$emit('input', value)
                this.$emit('update:modelValue', value)
            }
        }
    },
    created() {
        this.showModal = this.modelValue !== undefined ? this.modelValue : this.value;
    }
}
